import React, { useCallback, useEffect, useRef } from 'react';
import styles from './index.less';
import closeIcon from '../../assets/closeIcon.png';
import radio from '../../assets/radio.png';
import radioActive from '../../assets/radioActive.png';
import searchIcon from '../../assets/searchIcon.png';
import clearIcon from '../../assets/clearIcon.png';
import intl from 'react-intl-universal';

interface DownSelectSearchProps {
  title: string;
  showDownSelectSearch: boolean;
  setShowDownSelectSearch: (showDownSelectSearch: boolean) => void;
  selectedDownSelectSearchKey: string;
  setSelectedDownSelectSearch: (selectedDownSelectSearch: string) => void;
  setSelectedDownSelectSearchKey: (selectedDownSelectSearchKey: string) => void;
  list: any[];
  lable?: string;
  value?: string;
  loading?: boolean;
  callback?: (pageNo: number, retailerName: string) => void;
  searchValue: string;
  setSearchValue: (searchValue: string) => void;
  totalPages?: number;
  totalRecords?: number;
  PAGE_SIZE?: number;
  pageNo?: number;
  setPageNo?: (pageNo: number) => void;
  setDnsName?: (dnsName: string) => void;
}
function DownSelectSearch({
  title,
  showDownSelectSearch,
  setShowDownSelectSearch,
  selectedDownSelectSearchKey,
  setSelectedDownSelectSearch,
  setSelectedDownSelectSearchKey,
  list,
  lable = 'title',
  value = 'value',
  searchValue,
  setSearchValue,
  totalPages = 1,
  totalRecords = 0,
  PAGE_SIZE = 0,
  pageNo = 1,
  setPageNo,
  setDnsName
}: DownSelectSearchProps) {


  const downSelectSearchList = list;

  // 触底阈值与冷却时间（毫秒）
  const BOTTOM_THRESHOLD = 100;
  const COOLDOWN_MS = 3000;

  // 加载锁与冷却计时
  const isLockedRef = useRef(false);
  const lastTriggerTsRef = useRef(0);
  const cooldownTimerRef = useRef<number | null>(null);

  const releaseLock = useCallback(() => {
    isLockedRef.current = false;
  }, []);

  const triggerLoadMore = useCallback(() => {
    if (isLockedRef.current) return;
    const now = Date.now();
    if (now - lastTriggerTsRef.current < COOLDOWN_MS) return;

    isLockedRef.current = true;
    lastTriggerTsRef.current = now;
    if (pageNo && totalPages && pageNo < totalPages && setPageNo) {
      setPageNo(pageNo + 1)
    }

    // 若没有对接实际加载完成回调，则在冷却时间后自动解锁
    if (cooldownTimerRef.current) {
      clearTimeout(cooldownTimerRef.current);
    }
    cooldownTimerRef.current = window.setTimeout(() => {
      releaseLock();
    }, COOLDOWN_MS);
  }, [releaseLock, pageNo, totalPages, setPageNo]);

  const handleScroll = useCallback((e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
    const isNearBottom = scrollTop + clientHeight >= scrollHeight - BOTTOM_THRESHOLD;
    if (isNearBottom) {
      triggerLoadMore();
    }
  }, [triggerLoadMore]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPageNo && setPageNo(1)
    setSearchValue(e.target.value)
  }

  useEffect(() => {
    return () => {
      if (cooldownTimerRef.current) {
        clearTimeout(cooldownTimerRef.current);
      }
    }
  }, []);

  return (
    <div className={styles['downSelectSearchContainer']} style={{ display: showDownSelectSearch ? 'block' : 'none' }}>
      <div className={styles['downSelectSearchContent']}>
        <div className={styles['downSelectSearchTitle']}>
          <span>{title}</span>
          <img src={closeIcon} alt="" className={styles['downSelectSearchCloseIcon']} onClick={() => setShowDownSelectSearch(false)} />
        </div>
        {/* 搜索 */}
        <div className={styles['downSelectSearchSearch']}>
          <div className={styles['downSelectSearchInputContainer']}>
            <img src={searchIcon} alt="" className={styles['downSelectSearchSearchIcon']} />
            <input type="text" className={styles['downSelectSearchInput']} placeholder={intl.get('qrcode.signIn.search')} value={searchValue} onChange={handleSearch} />
          </div>
          {
            searchValue ? <img src={clearIcon} alt="" className={styles['downSelectSearchClearIcon']} onClick={() => setSearchValue('')} /> : null
          }
        </div>
        {
          downSelectSearchList.length ? <div className={styles['downSelectSearchList']} onScroll={handleScroll}>
            {
              // downSelectSearchList.filter((item) => item.title.includes(searchValue)).map((item) => {
              downSelectSearchList.map((item) => {
                return (
                  <div className={styles['downSelectSearchListItem']} key={item[value]} onClick={() => {
                    setDnsName && setDnsName(item.dnsName)
                    setSelectedDownSelectSearch(item[lable])
                    setSelectedDownSelectSearchKey(item[value])
                  }}>
                    <span>{item[lable]}</span>
                    <img src={selectedDownSelectSearchKey === item[value] ? radioActive : radio} alt="" className={styles['downSelectSearchListItemRadio']} />
                  </div>
                )
              })
            }
            {
              pageNo >= totalPages && totalRecords < PAGE_SIZE ? <div className={styles['downSelectSearchNoMoreData']}>
                <span>{intl.get('qrcode.signIn.noMoreData')}</span>
              </div> : null
            }
          </div> : totalRecords === 0 ? <div className={styles['downSelectSearchListLoading']}>
            <span>{intl.get('qrcode.signIn.noResultsFound')}</span>
          </div> : null
        }
      </div>
    </div>
  )
}

export default DownSelectSearch